// @flow
import React from "react";
import SvgIconContainer from '../SvgIconContainer';

export default (
	{
		unit = 'em',
		...rest
	}: Object = {}) => (
	<SvgIconContainer viewBox="0 0 16 16" {...rest} unit={unit}>
		<g stroke="none" strokeWidth="1" fillRule="evenodd">
			<g transform="translate(1.000000, 1.000000)">
				<g transform="translate(2.100000, 0.000000)">
					<path d="M7.02657798,0.816797354 L6.56234427,0 L3.23730337,0 L2.77324584,
					0.816797354 L0,0.816797354 L0,2.62700699 L9.8,2.62700699 L9.8,
					0.816797354 L7.02657798,0.816797354 Z M2.86503551,6.98133035
					L3.73712539,6.05736918 L4.89973573,7.28937963 L6.06234607,
					6.05736918 L6.93461213,6.98133035 L5.77182562,8.2135275 L6.93478831,
					9.44591135 L6.06252225,10.3698725 L4.89973573,9.13767536 L3.73712539,
					10.3696858 L2.86503551,9.44572465 L4.02782202,8.2135275 L2.86503551,
					6.98133035 Z M0.524663371,12.5064277 C0.524663371,13.331253 1.15573933,
					14 1.93410157,14 L7.86572225,14 C8.64408449,14 9.27516045,13.331253
					9.27516045,12.5064277 L9.27516045,3.1170854 L0.524663371,3.1170854
					L0.524663371,12.5064277 Z" />
				</g>
			</g>
		</g>
	</SvgIconContainer>
);


// WEBPACK FOOTER //
// ./src/components/Icons/Delist.js